"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.defaultDescriptor = void 0;
exports.mergeProperties = mergeProperties;
function mergeProperties(dest, src) {
  Object.getOwnPropertyNames(src).forEach(function forEachOwnPropertyName(name) {
    if (Object.hasOwnProperty.call(dest, name)) {
      return;
    }
    var descriptor = Object.getOwnPropertyDescriptor(src, name);
    Object.defineProperty(dest, name, descriptor);
  });
  return dest;
}
function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
var defaultDescriptor = exports.defaultDescriptor = {
  writable: true,
  enumerable: true,
  configurable: false
};